export default "__VITE_ASSET__BmxsM0hZ__"